<template>
    <div :class="$style.product">
        <div :class="$style.product_cover">
            <nuxt-link :to="url" :title="data.name">
                <el-image :class="$style.product_img" :src="data.image" fit="cover" :alt="data.name" />
            </nuxt-link>
            <template v-if="loggedIn">
                <el-image v-if="isFavorite" alt="取消收藏" :class="$style.product_collect" lazy @click="$emit('collect')"
                    fit="cover" src="~@/assets/img/resource/collected-icon.png" />
                <el-image alt="收藏" v-else :class="$style.product_collect" lazy @click="$emit('collect')" fit="cover"
                    src="~@/assets/img/resource/collect-icon.png" />
            </template>
        </div>
        <div :class="$style.product_content">
            <div :class="$style.product_detail_wrap">
                <h3 :class="$style.product_name"><nuxt-link :to="url" :title="data.name">{{ data.name }}</nuxt-link></h3>
                <div v-if="data.tags" :class="$style.product_tags">
                    <span :class="$style.product_tag" v-for="tag in data.tags">{{ tag }}</span>
                </div>
                <div v-if="data.departure" :class="$style.product_detail">
                    <span :class="$style.product_detail_icon"><i class="ficon ficon-ziyuancaigou_chufa"></i></span>
                    <span :class="$style.product_detail_content">
                        <span :class="$style.product_detail_label">出发：</span>
                        {{ data.departure }}
                    </span>
                </div>
                <div v-if="data.product_date" :class="$style.product_detail">
                    <span :class="$style.product_detail_icon"><i class="ficon ficon-ziyuancaigou_chufariqi"></i></span>
                    <span :class="$style.product_detail_content">
                        <span :class="$style.product_detail_label">{{ data.product_date.length }}个出发日期：</span>
                        {{ data.product_date.join('、') }}
                    </span>
                </div>

            </div>
        </div>
        <div :class="$style.product_price_wraper">
            <template v-if="isDistributor">
                <div :class="[$style.product_price, $style.sale]">
                    <span :class="$style.product_price_label">零售价：</span>
                    <span :class="$style.product_price_curr">￥</span>
                    <span :class="$style.product_price_num">{{ data.min_sale_price }}</span>
                    <span :class="$style.product_price_unit">起/人</span>
                </div>
                <div :class="$style.product_price">
                    <span :class="$style.product_price_label">同行价：</span>
                    <span :class="$style.product_price_curr">￥</span>
                    <span :class="$style.product_price_num">{{ data.min_th_price }}</span>
                    <span :class="$style.product_price_unit">起/人</span>
                </div>
            </template>
            <div v-else :class="$style.product_price">
                <span :class="$style.product_price_curr">￥</span>
                <span :class="$style.product_price_num">{{ data.min_sale_price }}</span>
                <span :class="$style.product_price_unit">起/人</span>
            </div>
<!--            <div v-if="profitText" :class="$style.product_profit">-->
<!--                <span :class="$style.product_profit_label">利润</span>-->
<!--                <span :class="$style.product_profit_value">{{ profitText }}</span>-->
<!--            </div>-->
        </div>

        <div :class="$style.product_footer">
            <el-button :class="$style.product_action" v-if="!isInShop && isDistributor && isAdmin && isOpenShop"
                icon="ficon ficon-dianpuguanlishuju" @click="$emit('join')">
                加入店铺</el-button>
            <el-button :class="$style.product_action" v-if="isDistributor" icon="ficon ficon-xingzhuangjiehe2"
                @click="$emit('share')">
                分享产品</el-button>
            <el-button :class="$style.product_action" class="w-35" type="primary" @click="onView">查看详情</el-button>
        </div>
    </div>
</template>

<script>
import { computed, defineComponent, useStore } from '@nuxtjs/composition-api';
import { profitFormat } from "@/utils/product";

export default defineComponent({
    name: 'ProductItem',

    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ['collect', 'join', 'share', 'view'],
    setup(props) {
        const depStr = computed(() => props.data.city.map(c => c.city_name).join('、'));

        const url = computed(() => `/product/vacation/${props.data.product_no}`)

        const store = useStore();
        const isDistributor = computed(() => store.getters.isDistributor);
        const isAdmin = computed(() => store.getters.isAdmin);
        const loggedIn = computed(() => store.getters.loggedIn);
        const isInShop = computed(() => !!props.data.in_shop);
        const isOpenShop = computed(() => store.getters.isOpenShop)
        const isFavorite = computed(() => !!props.data.is_favorite);


        const profitText = computed(() => profitFormat(props.data.min_profit, props.data.max_profit))
        const onView = () => {
            window.open(url.value, '_blank');
        }
        return {
            profitText,

            depStr,
            url,

            isDistributor,
            isAdmin,
            loggedIn,
            isOpenShop,
            isInShop,
            isFavorite,

            onView
        }
    }
})
</script>

<style lang="scss" module>
.product {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin-bottom: 0.75rem;
  position: relative;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
}
.product:last-child {
  margin-bottom: 0px;
}
.product:hover .product_name {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.product_cover {
  border-radius: 0.25rem;
  height: 17.25rem;
  position: relative;
  width: 19.25rem;
}
.product_img {
  border-radius: 0.25rem;
  height: 100%;
  width: 100%;
}
.product_collect {
  cursor: pointer;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 2.5rem;
}
.product_content {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  margin-left: 0.25rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  padding-right: 15rem;
}
.product_name {
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.75rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.product_detail {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product_detail_icon {
  font-size: 1.25rem;
  line-height: 1.75rem;
  line-height: 1.5rem;
  margin-right: 0.5rem;
}
.product_detail_content {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.product_tags {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.product_tag {
  --tw-bg-opacity: 1;
  background-color: rgba(186, 131, 43, var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
  border-radius: 0.125rem;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: -webkit-inline-flex;
  display: inline-flex;
  font-size: 0.8125rem;
  line-height: 1.125rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  --tw-text-opacity: 1;
  color: rgba(76, 48, 3, var(--tw-text-opacity));
}
.product_tag+.product_tag {
  margin-left: 0.5rem;
}
.product_price {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: baseline;
  -ms-flex-align: baseline;
  -webkit-align-items: baseline;
  align-items: baseline;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
}
.product_price.sale .product_price_curr {
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product_price.sale .product_price_num {
  font-size: 1.25rem;
  line-height: 1.75rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product_price_wraper {
  position: absolute;
  right: 1rem;
  top: 1.5rem;
  text-align: right;
}
.product_price_curr, .product_price_num {
  --tw-text-opacity: 1;
  color: rgba(204, 75, 12, var(--tw-text-opacity));
}
.product_price_curr {
  font-size: 1rem;
  line-height: 1.5rem;
}
.product_price_num {
  font-weight: 500;
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.product_price_unit {
  font-size: 1rem;
  line-height: 1.5rem;
  margin-left: 0.25rem;
}
.product_profit {
  --tw-bg-opacity: 1;
  background-color: rgba(31, 33, 41, var(--tw-bg-opacity));
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: -webkit-inline-flex;
  display: inline-flex;
  height: 1.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 1.5rem;
  margin-top: 0.25rem;
  overflow: hidden;
  border-radius: 12px 2px 12px 2px;
}
.product_profit_label {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.product_profit_value {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 169, 0, var(--tw-bg-opacity));
  font-weight: 500;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product_footer {
  position: absolute;
  right: 1rem;
  bottom: 1.5rem;
}
.product_action {
  border-radius: 0.25rem;
  min-width: 6.25rem;
}
.product :global(.el-button--default) {
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  border: 1px solid var(--border-color-darker);
}
.product :global(.el-button--default):hover {
  border-color: var(--color-primary);
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
</style>
